var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('welcome-panel',[_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.description))])]),_c('home-counters',{attrs:{"show-admin":_vm.showAdmin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }